(ns common.schema.entities.workspace.kyc.questions.questions-registry
  (:require
   [common.schema.entities.workspace.kyc.questions.legal-entity :as legal-entity]
   [common.schema.entities.workspace.kyc.questions.natural-person :as natural-person]
   [common.schema.entities.workspace.kyc.questions.tenant :as tenant]
   [common.schema.entities.workspace.kyc.questions.contract :as contract]
   [common.schema.entities.workspace.kyc.questions.pep :as pep]
   [common.schema.entities.workspace.kyc.questions.ubo :as ubo]
   [common.schema.entities.workspace.kyc.questions.board-member :as board-member]
   [common.schema.entities.workspace.kyc.questions.smo :as smo]
   [common.schema.entities.workspace.kyc.questions.substantial-us-owner :as substantial-us-owner]
   [common.schema.entities.workspace.kyc.questions.controlling-person :as controlling-person]
   [common.schema.entities.workspace.kyc.questions.flow-through-jurisdiction :as flow-through-jurisdiction]))

(def all-questions
  (merge pep/all-questions
         ubo/all-questions
         legal-entity/all-questions
         natural-person/all-questions
         board-member/all-questions
         smo/all-questions
         tenant/all-questions
         contract/all-questions
         substantial-us-owner/all-questions
         controlling-person/all-questions
         flow-through-jurisdiction/all-questions))

(defn resolve-questions
  [sorted-question-kws]
  (->> sorted-question-kws
       (map-indexed (fn [idx questions]
                      (let [[kw override-meta] questions]
                        (if-let [meta (all-questions kw)]
                          (let [ordered-meta (assoc meta :ord idx)]
                            [kw
                             (if (seq override-meta)
                               (merge ordered-meta override-meta)
                               ordered-meta)])
                          #?(:cljs (js/console.error "Unknown KYC question " kw)
                             :clj (pr "Unknown KYC question " kw))))))
       (into {})))
